import { useMemo } from 'react';
import { ReactComponent as SvgRisk1 } from '../../../assets/icons/risk/risk-1.svg.js';
import { ReactComponent as SvgRisk2 } from '../../../assets/icons/risk/risk-2.svg.js';
import { ReactComponent as SvgRisk3 } from '../../../assets/icons/risk/risk-3.svg.js';
import { ReactComponent as SvgRisk4 } from '../../../assets/icons/risk/risk-4.svg.js';
import { ReactComponent as SvgRisk5 } from '../../../assets/icons/risk/risk-5.svg.js';
import { getRisk } from './util.js';
import { useTranslation } from 'react-i18next';

var useRisks = function (short) {
    if (short === void 0) { short = false; }
    var t = useTranslation("zignaly-ui", { keyPrefix: "ZigRisk" }).t;
    return useMemo(function () {
        return [
            {
                icon: SvgRisk1,
                label: t("very-low".concat(short ? "" : "-risk")),
                color: "#24b88e",
                id: 0,
                zrisk: 24,
            },
            {
                icon: SvgRisk2,
                label: t("low".concat(short ? "" : "-risk")),
                color: "#9fcb6e",
                id: 1,
                zrisk: 18,
            },
            {
                icon: SvgRisk3,
                label: t("average".concat(short ? "" : "-risk")),
                color: "#c2b864",
                id: 2,
                zrisk: 12,
            },
            {
                icon: SvgRisk4,
                label: t("risky"),
                color: "#e7a675",
                id: 3,
                zrisk: 6,
            },
            {
                icon: SvgRisk5,
                label: t("very-risky"),
                color: "#f14a84",
                id: 4,
                zrisk: 0,
            },
        ];
    }, []);
};
var useRisk = function (zrisk, short) {
    var risks = useRisks(short);
    return useMemo(function () {
        return getRisk(zrisk, risks);
    }, [zrisk, risks]);
};

export { useRisk, useRisks };
